import { render, staticRenderFns } from "./page-language-switcher.vue?vue&type=template&id=1fdad322&scoped=true&"
import script from "./page-language-switcher.vue?vue&type=script&lang=ts&"
export * from "./page-language-switcher.vue?vue&type=script&lang=ts&"
import style0 from "./page-language-switcher.vue?vue&type=style&index=0&id=1fdad322&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fdad322",
  null
  
)

export default component.exports